import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject, of} from 'rxjs';
import {Observable} from 'rxjs-compat';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {UnitApplicationParentType} from 'src/app/shared/enums/unit-bank-account/UnitApplicationParentType.enum';
import {UnitCreateBankAccountParams} from 'src/app/shared/models/unit-bank-account/UnitCreateBankAccountParams.model';

import {CreateUnitBankAccountStep, UnitCreateBankAccountService} from './unit-create-bank-account.service';
import UnitAccountProvider from '../../../enums/UnitAccountProvider.enum';
import {UserService} from '../../../../services/shared/user.service';

@Component({
  selector: 'terra-unit-create-bank-account',
  templateUrl: './unit-create-bank-account.component.html',
  styleUrls: ['./unit-create-bank-account.component.scss', '../unit-shared.scss'],
  providers: [UnitCreateBankAccountService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitCreateBankAccountComponent implements OnInit {

  holdingId: number = null;
  unitApplicationId: number = null;
  organizationDetailsId: number = null;

  // consts
  CreateUnitBankAccountStep = CreateUnitBankAccountStep;

  originUrl$: Observable<string>;

  step$ = this.unitCreateBankAccountService.step$;

  processingSubmit$ = new BehaviorSubject(false);
  isGeneralServerError$ = new BehaviorSubject(false);

  isCreateFailed$ = this.unitCreateBankAccountService.isCreateFailed$.pipe(shareReplay(1));
  showExternalOption = false;

  bankingProvider: UnitAccountProvider;
  bankingProviderString$ = this.userService.accountDetails$.pipe(
    switchMap(user => {
      const orgAccountProvider = user?.organizationDetails?.unitAccountProvider;
      this.bankingProvider = orgAccountProvider == null ? UnitAccountProvider.Thread : orgAccountProvider;
      return of(UnitAccountProvider.toProvidedBy(this.bankingProvider));
    })
  );

  accountProvider$ = this.userService.accountDetails$.pipe(
    map(user => {
      return user?.organizationDetails?.unitAccountProvider || UnitAccountProvider.Thread;
    })
  );

  constructor(private unitCreateBankAccountService: UnitCreateBankAccountService,
              @Inject(MAT_DIALOG_DATA) public data: UnitCreateBankAccountParams,
              private dialogRef: MatDialogRef<UnitCreateBankAccountComponent>,
              private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.parseData();
    if (this.data.preselectedType === UnitApplicationParentType.Holding) {
      this.unitCreateBankAccountService.passHoldingId(this.data.attachedToId);
    }
    this.originUrl$ = this.unitCreateBankAccountService.originUrl(this.data.preselectedType);
  }

  parseData() {
    this.showExternalOption = this.data?.showExternalOptions;
  }

  onBankAccountAdded(event) {
    this.dialogRef.close({reason: 'new', payload: event.payload});
  }

  onDialogClosed(data) {
    this.dialogRef.close(data);
  }
}
